import React, { useCallback } from 'react'
import { useUpdateLog } from 'utils/log'
import LabelLine from '../items/LabelLine'
import { FormTitleProps } from '../items/FormTitle'
import SwitchLine from '../items/SwitchLine'
import BaseGroup from './BaseGroup'

/** SwitchButtonGroupのタイプ定義 */
export type SwitchItemGroupProps = FormTitleProps & {
  /** スイッチの入力状態 */
  isSwitched: boolean
  /** スイッチの文言 */
  label: string
  /** スイッチ上部に表示させるメッセージ */
  message?: string
  /** 破損個所の変更コールバック */
  onChanged?: (value: boolean) => void
}

/**
 * スイッチボタングループ
 */
const SwitchButtonGroup: React.FC<SwitchItemGroupProps> = (props) => {
  const {
    title,
    isRequired,
    description,
    hideTitle,
    isSwitched,
    label,
    message,
    onChanged,
  } = props
  /** スイッチがクリックされた時のコールバック */
  const handleSwitchClick = useCallback((): void => {
    if (onChanged) {
      onChanged(!isSwitched)
    }
  }, [isSwitched, onChanged])

  useUpdateLog(
    title,
    {
      title: title,
      isRequired: isRequired,
      isSwitched: isSwitched,
    },
    [props]
  )

  return (
    <BaseGroup
      isRequired={isRequired}
      title={title}
      description={description}
      hideTitle={hideTitle}
    >
      {message && <LabelLine label={message} />}
      <SwitchLine
        isSwitched={isSwitched}
        label={label}
        onClick={handleSwitchClick}
      />
    </BaseGroup>
  )
}

export default React.memo<SwitchItemGroupProps>(SwitchButtonGroup)
